export const typeOfRsProjectParametersDialog = 'typeOfRsProjectParametersDialog';
export const typeOfRsSimilaritySearchDialog = 'typeOfRsSimilaritySearchDialog';
export const typeOfDialogWithConfirmationLayout = 'typeOfDialogWithConfirmationLayout';
export const typeOfDialogWithErrorLayout = 'typeOfDialogWithErrorLayout';
export const typeOfDialogWithInfoLayout = 'typeOfDialogWithInfoLayout';
export const typeOfDialogWithSuccessLayout = 'typeOfDialogWithSuccessLayout';
export const typeOfDialogWithWarningLayout = 'typeOfDialogWithWarningLayout';

export const NOTIFICATION_DIALOG_TYPES = {
  error: typeOfDialogWithErrorLayout,
  info: typeOfDialogWithInfoLayout,
  warning: typeOfDialogWithWarningLayout,
  success: typeOfDialogWithSuccessLayout,
  confirm: typeOfDialogWithConfirmationLayout,
};
